import React from 'react'
import PropTypes from 'prop-types'
import Loader from '../../../Search/Loader'

import './DownloadCSVForm.css'

const MAX_LINE_COUNT = 200000;

class DownloadCSVForm extends React.Component {

    state={
        lineCount: 10000,
        offset: 0,
        showOffset: false,
        loading: false,
        download: false
    }

    makeRequestHandler = (e) => {
        e.preventDefault();
        this.setState({download: true, loading: true})
        const joinChar = this.props.activeQuery.includes('?') ? '&' : '?';
        fetch(`${this.props.hostname}${this.props.activeQuery}${joinChar}offset=${this.state.offset}&limit=${this.state.lineCount}`)
            .then(res => res.json())
            .then(data => {
                this.setState({loading: false})
                this.downloadAsCSV(data)
            })
    }

    downloadAsCSV = (data) => {
        const cols = data.length > 0 && typeof(data[0] === 'object') ? Object.keys(data[0]) : [];
        let csvArray = [cols.join(";")];
        data.forEach(item => {
            csvArray.push(Object.values(item).join(";"))
        })
        const csvData = new Blob([csvArray.join("\r\n")], { type: 'text/csv'});
        const encodedCSV = URL.createObjectURL(csvData);
        const link = document.createElement("a");
        link.href = encodedCSV;
        link.download = "ordtidnigogn.csv";
        link.click();
    }

    lineCountChangedHandler = (e) => {
        let val = e.target.value;
        if (val < 0) {
            val = 0;
        }
        if (val > MAX_LINE_COUNT) {
            val = MAX_LINE_COUNT
        }
        this.setState({lineCount: val})
    }

    offsetChangedHandler = (e) => {
        let val = e.target.value;
        if (val < 0) {
            val = 0;
        }
        if (val > MAX_LINE_COUNT) {
            val = MAX_LINE_COUNT
        }
        this.setState({offset: val})
    }

    render () {
        const offsetButton = (
            <button className="btn"
                type="button"
                onClick={() => this.setState({showOffset: true})}
                >
                Sleppa línum?
            </button>
        )

        const offsetInput = (
            <label>
                Sleppa fyrstu

                <input
                    type="number"
                    value={this.state.offset}
                    onChange={this.offsetChangedHandler}
                    />

                línum
            </label>
        )

        return (
            <form className='DownloadCSVForm' onSubmit={this.makeRequestHandler}>
                <h1>Hala niður gögnum á CSV-sniði</h1>
                <p style={{wordBreak: 'break-word'}}>Virk fyrirspurn: {this.props.activeQuery}</p>
                <label>
                    Fjöldi lína til að sækja:
                    <input
                      type="number"
                      value={this.state.lineCount}
                      onChange={this.lineCountChangedHandler}
                      />
                </label>
                {this.state.showOffset ? offsetInput : offsetButton}
                <input type="submit" value="Staðfesta"/>
                <Loader loading={this.state.loading} />
                <button className="btn" type='button' onClick={this.props.cancel}>
                    Hætta við
                </button>
            </form>
        )
    }
}

DownloadCSVForm.propTypes = {
    activeQuery: PropTypes.string.isRequired,
    hostname: PropTypes.string.isRequired,
    confirm: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired
    // makeRequest: PropTypes.func.isRequired
}

export default DownloadCSVForm;



// WEBPACK FOOTER //
// ./src/Components/DownloadCSVModal/DownloadCSVForm/DownloadCSVForm.js